import BirdPlayer from './BirdPlayer';

export default BirdPlayer;
